import { Component, Input, forwardRef, Inject, ElementRef, AfterViewInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'gtd-form-field-confirm-code',
  templateUrl: './confirm-code.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ConfirmCodeComponent),
      multi: true,
    },
  ],
})
export class ConfirmCodeComponent implements AfterViewInit, ControlValueAccessor {
  @Input() cssClass: string;
  @Input() lengthCode = 6;
  @Input() errorText: string;
  public value = '';
  private onChange: (value: string) => void = () => {};
  private onTouched: any = () => {};

  constructor(@Inject(ElementRef) private readonly elementRef: ElementRef) {}

  ngAfterViewInit(): void {
    this.elementRef.nativeElement.children[0].children[0].disabled = false;
  }

  onInput(event, index: number): void {
    [].forEach.call(event.target.value, (num: string, i: number) => {
      const j = index + i;
      if (j < this.lengthCode) {
        this.elementRef.nativeElement.children[0].children[j].value = num;
      }
    });
    if (this.elementRef.nativeElement.children[0].children[index]) {
      if (index < this.lengthCode - 1 && event.data) {
        this.elementRef.nativeElement.children[0].children[index + 1].disabled = false;
        this.elementRef.nativeElement.children[0].children[index + 1].focus();
      } else if (event.data) {
        this.elementRef.nativeElement.children[0].children[index].blur();
      }
    }
    this.value = [].reduce.call(
      this.elementRef.nativeElement.children[0].children,
      (acc: string, elem: HTMLInputElement) => (acc += elem.value),
      ''
    );
    this.onChange(this.value);
    this.onTouched();
  }

  onFocus(event, index: number): void {
    if (event.target.value) {
      this.elementRef.nativeElement.children[0].children[index].select();
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(value): void {
    if (value) {
      this.value = value;
    }
  }
}
